
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
export class IspringCardConfiguration extends MaterialConfiguration {
    constructor(course: any) {
        super();
        this.tagType = 'material';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/elearning.png';
        this.classType = 'iSpring';
        this.subtitle = 'branded.portal.courses.assignment.material.ispring.subtitle';
        this.multiContent = course.contents.length > 1;
        this.expired = !course.enabled;
        this.clickable = !this.expired;
        this.action = LinkActions.DOWNLOAD;
        this.links = [{
                disabled: this.expired,
                tooltip: this.expired ? 'branded.portal.courses.assignment.ispring.download.tooltip' : null,
                url: this.expired ? '' : course.downloadLink,
                text: 'branded.portal.courses.assignment.ispring.download.text',
                type: LinkActions.DOWNLOAD,
                image: this.expired ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/download-inactive.svg' :
                    'https://itpx-branded-portal-dev.s3.amazonaws.com/download.svg'
            }];
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/ispring-card-configuration.ts